import "./styles.less";

import React, { useContext } from "react";
import { useActiveFiltersTags } from "./ActiveFiltersTags.hook";
import { ConfigStateContext } from "../../../../Contexts/Configurations/context";

const ActiveFiltersTags = () => {
	const { country_code } = useContext(ConfigStateContext);
	const { filtersTagsToShow, changeFilters } = useActiveFiltersTags();

	return (
		<div className="filter-tag-wrap">
			{filtersTagsToShow.map((o, i) => {
				// if (country_code === "ce3" && o.value === 4) {
				// 	return null;
				// }

				return (
					<span className="filter-tag" key={o.key + "_" + i}>
						{o.text}
						{o.deleteable &&
							<span className="close" onClick={() => { changeFilters(o.onChangeObject) }}>x</span>
						}
					</span>

				);
			})}
		</div>
	);
};

export { ActiveFiltersTags };
